import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CustomerLookupForm, CustomerSearchParams } from './CustomerLookupForm';
import { CustomerLookupResults } from './CustomerLookupResults';

export const CustomerLookup = () => {
  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const [showResults, setShowResults] = useState(false);
  const [searchParamsState, setSearchParamsState] = useState<CustomerSearchParams>({
    email: '',
    order_id: '',
    phone_number: '',
    first_name: '',
    last_name: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    zip_code: '',
    country: '',
    pet_name: '',
  });

  useEffect(() => {
    const params: CustomerSearchParams = {
      email: urlSearchParams.get('email') ?? '',
      order_id: urlSearchParams.get('order_id') ?? '',
      phone_number: urlSearchParams.get('phone_number') ?? '',
      first_name: urlSearchParams.get('first_name') ?? '',
      last_name: urlSearchParams.get('last_name') ?? '',
      address_1: urlSearchParams.get('address_1') ?? '',
      address_2: urlSearchParams.get('address_2') ?? '',
      city: urlSearchParams.get('city') ?? '',
      state: urlSearchParams.get('state') ?? '',
      zip_code: urlSearchParams.get('zip_code') ?? '',
      country: urlSearchParams.get('country') ?? '',
      pet_name: urlSearchParams.get('pet_name') ?? '',
    };

    const hasAny = Object.values(params).some((p) => p !== '');

    if (hasAny) {
      setSearchParamsState(params);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  }, [urlSearchParams]);

  const handleSearch = (params: CustomerSearchParams) => {
    // url search params should only be non-empty params
    const sanitized: Record<string, string> = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v && v !== '')
    );

    setUrlSearchParams(sanitized);
    setSearchParamsState(params);
    setShowResults(true);
  };

  return (
    <div className="flex h-[calc(100vh-77px)] overflow-auto items-center justify-center bg-slate50 px-4">
      <div className="min-w-[300px] w-full flex items-center justify-center">
        {!showResults && <CustomerLookupForm handleSearch={handleSearch} />}
        {showResults && (
          <CustomerLookupResults
            searchParams={searchParamsState}
            onClick={() => setShowResults(false)}
          />
        )}
      </div>
    </div>
  );
};
